import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/Ishitasharma0318" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://linkedin.com/in/ishitasharma03" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <p>A portfolio designed and built by <a href="https://github.com/Ishitasharma0318" target="_blank" rel="noreferrer">Ishita Sharma</a> with 💜</p>
    </footer>
  );
}

export default Footer;